import PlatePreviewCard from './PlatePreviewCard';

export default PlatePreviewCard;
